import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { LESSON_POINTS } from "@/data/lessonPoints";

export const SectionText = ({ s, i }) => {
  const [open, setOpen] = useState(false);
  const pts = s.points || LESSON_POINTS[s.heading];
  if (!pts) return <p className="mt-3 leading-relaxed text-muted-foreground">{s.text}</p>;
  return (
    <div className="mt-3" data-testid={`section-points-${i}`}>
      <ul className="space-y-1.5">
        {pts.map((p) => (
          <li key={p} className="flex gap-2.5 text-foreground"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />{p}</li>
        ))}
      </ul>
      <button onClick={() => setOpen((o) => !o)} data-testid={`read-more-${i}`} className="mt-3 flex items-center gap-1.5 text-base font-semibold text-primary hover:underline">
        {open ? "Show less" : "Read more"} <ChevronDown size={18} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <p className="mt-2 text-sm leading-relaxed text-muted-foreground" data-testid={`read-more-text-${i}`}>{s.text}</p>}
    </div>
  );
};
